import { Divider, Grid, Typography } from "@mui/material";
import { Dispatch, SetStateAction, useMemo } from "react";
import { useChatContext } from "stream-chat-react";
import { useUser } from "../../../../Hooks/useUser";
import { useGetTalentsToMessageQuery } from "../../../../Redux/api/clientApi";
import { ComposeMessageTalent } from "../../../../Types/Client";
import { Recepient } from "../Recepient";
import TalentSearch from "../../../../Shared Components/TalentSearch";
import { useAppSelector } from "../../../../Redux/store";
import ComposeMessageTalentSearch from "./ComposeMessageTalentSearch";

interface IProps {
    hiredTalents: ComposeMessageTalent[] | undefined;
    selectedRecepient: ComposeMessageTalent | undefined;
    setSelectedRecepient: Dispatch<SetStateAction<ComposeMessageTalent | undefined>>
}

const ClientComposeContent = ({ hiredTalents, selectedRecepient, setSelectedRecepient}:IProps) => {
    /* ******************** Hooks ******************** */
    const { locator, hasPremium } = useUser();
    const { client } = useChatContext();
    /* ******************** Variables ******************** */    
    const existingConversations = Object.values(client.activeChannels).map( a => Object.values(a.state.members).filter( m => m?.user_id !== locator).flat()[0]?.user_id)
    const filteredHiredTalents = useMemo(() => {
        if (hiredTalents && existingConversations) {
            return hiredTalents.filter( t => !existingConversations.some( e => e === t.locator));
        } else {
            return [];
        }
    }, [hiredTalents, existingConversations]);
    /* ******************** Functions ******************** */
    const handleCheck = (user: any) => {
        if (selectedRecepient && selectedRecepient.locator === user.locator){ 
            setSelectedRecepient(undefined);
        } else {
            setSelectedRecepient(user);
        }
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <Grid container gap={'20px'} display={'flex'} flexDirection={'column'}>  
            <ComposeMessageTalentSearch 
                {...{ selectedRecepient, existingConversations, hiredTalents, handleCheck }}
            />
            {
                filteredHiredTalents.length > 0 &&
                <>
                     <Divider/>
                    <Typography>Hired Talents</Typography>                  
                    <Grid display={'flex'} flexDirection={'column'} gap={2} maxHeight={'154px'} overflow={'auto'}>
                        {
                            filteredHiredTalents.map( (j, idx) => (                                    
                                <Recepient 
                                    key={idx}
                                    user={j} 
                                    selectedRecepient={selectedRecepient} 
                                    handleCheck={handleCheck}
                                />
                            ))
                        }
                    </Grid>
                </>
            }
        </Grid>
    )
}

// For when I add the premium prompt
//     //         <Snackbar
//     //             open={disableMessaging && type == ProfileType['Client']}
//     //             anchorOrigin={{
//     //                 vertical: 'top',
//     //                 horizontal: 'center',
//     //             }}
//     //             sx={{
//     //                 width: '100%', 
//     //                 marginTop: 8.75, 
//     //                 marginLeft: 14,
//     //                 "  > .MuiPaper-root": {
//     //                     backgroundColor: '#FBE3A5',
//     //                     color: "#000",
//     //                     borderRadius: '8px',
//     //                 }
//     //             }}
//     //         >
//     //             <SnackbarContent 
//     //                 message={'You’ve reached your message limit for the month. Upgrade to Premium get unlimited messaging.'}
//     //                 action={
//     //                     <Button variant='outlined' onClick={handleUpgrade}>Upgrade</Button>
//     //                 }
//     //             />
//     //         </Snackbar>
export default ClientComposeContent